var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error-view"},[_c('div',{staticClass:"error-container"},[_c('div',{staticClass:"error-logo"},[_c(_setup.FeedbackCompanyLogo)],1),_c('div',{staticClass:"error-message"},[_vm._v("Oops, we can't find that page.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }